import { render, staticRenderFns } from "./blackUfw.vue?vue&type=template&id=f57a415c&scoped=true"
import script from "./blackUfw.vue?vue&type=script&lang=js"
export * from "./blackUfw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57a415c",
  null
  
)

export default component.exports